// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./accordion_ripple"
import * as bootstrap from "bootstrap"
import "./cart"
import "./turbo_stream_actions"
import "./gtm_turbo"

window.bootstrap = bootstrap;

//Turbo.session.drive = false;

// Back to Top
import {addBackToTop} from 'vanilla-back-to-top'

// Chatra - LiveChat
import Chatra from '@chatra/chatra';

const chatConfig = {
    setup: {
        buttonSize: 50,
        colors: {
            buttonText: '#ffffff',
            buttonBg: '#663399'
        }
    },
    ID: '7aowCmfBcjkAdYS2R'
}

const initChatra = () => {
    if (window._chatraInitialized) {
        // Re-init on Turbo navigations so Chatra can restart/re-attach if needed.
        Chatra('init', chatConfig);
        return;
    }

    Chatra('init', chatConfig);
    window._chatraInitialized = true;
}

const scheduleChatraInit = () => {
    if (window._chatraInitialized || window._chatraScheduled) return;

    window._chatraScheduled = true;
    const run = () => {
        window._chatraScheduled = false;
        initChatra();
    }

    // Fallback for visitors who never interact. First interaction (scroll,
    // touch, keydown) remains the primary trigger; this must stay well clear
    // of the critical loading window — the widget is ~320KB.
    const scheduleAfterLoad = () => setTimeout(run, 8000);
    if (document.readyState === 'complete') {
        scheduleAfterLoad();
    } else {
        window.addEventListener('load', scheduleAfterLoad, {once: true});
    }
}

const bindChatraEarlyInteractionInit = () => {
    if (window._chatraInitialized || window._chatraInteractionBound) return;

    const events = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    const onFirstInteraction = () => {
        events.forEach((eventName) => {
            window.removeEventListener(eventName, onFirstInteraction);
        });

        window._chatraInteractionBound = false;
        initChatra();
    }

    window._chatraInteractionBound = true;
    events.forEach((eventName) => {
        window.addEventListener(eventName, onFirstInteraction, {passive: true});
    });
}

// Glightbox
import GLightbox from 'glightbox';

// noUiSlider - for range sliders
import noUiSlider from 'nouislider';

window.noUiSlider = noUiSlider;


document.addEventListener("turbo:load", () => {
    if (window._chatraInitialized) {
        initChatra();
    }

    bindChatraEarlyInteractionInit();
    scheduleChatraInit();

    addBackToTop({
        diameter: 50,
        backgroundColor: 'transparent',
        textColor: '#000'
    });

    // getOrCreateInstance, never dispose/recreate: elements that survive the
    // visit (e.g. the collection filter drawer during a promoted frame visit)
    // must keep their live instance — a recreated one believes it is closed
    // and can no longer be dismissed while the drawer is shown. An element
    // with .show but NO instance was restored from a snapshot cached while
    // open; reset it to closed or it renders as an undismissable drawer.
    document.querySelectorAll('.offcanvas').forEach(offcanvasEl => {
        if (!bootstrap.Offcanvas.getInstance(offcanvasEl)) {
            offcanvasEl.classList.remove('show', 'showing', 'hiding');
        }
        bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
    });

    // With no offcanvas legitimately open, restored snapshots must not leave
    // an orphaned backdrop or body scroll lock behind.
    if (!document.querySelector('.offcanvas.show')) {
        document.querySelectorAll('.offcanvas-backdrop').forEach(backdrop => backdrop.remove());
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');
    }

    GLightbox({
        selector: ".lightbox",
        touchNavigation: true,
        showImageTitle: false,
        openEffect: 'zoom',
        closeEffect: 'fade',
        slideExtraAttributes: []
    });
});
